import React from "react";
import Button from "../../components/Button";
import { View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import { useSnackbar } from "../../hooks/snackbar";
import type { Meta, StoryObj } from "@storybook/react";

const ComponentStory = () => {
    const { showSnackbar, clearSnackbar } = useSnackbar();
    return (
        <VStack gap={0.5} alignment="stretch" style={{ width: "100%" }}>
            <Button
                label="Show static"
                onPress={() =>
                    void showSnackbar({ text: "This is a STATIC snackbar", timeout: -1 })
                }
            />
            <Button
                label="Show default"
                onPress={() => void showSnackbar({ text: "This is a default snackbar" })}
            />
            <Button
                label="Show error"
                onPress={() =>
                    void showSnackbar({ text: "This is an error snackbar", mode: "error" })
                }
            />
            <Button
                label="Show success"
                onPress={() =>
                    void showSnackbar({ text: "This is a success snackbar", mode: "success" })
                }
            />
            <Button
                label="Show info"
                onPress={() =>
                    void showSnackbar({ text: "This is an info snackbar", mode: "info" })
                }
            />
            <Button
                label="Big text"
                onPress={() =>
                    void showSnackbar({
                        text: "This is an info snackbar that can spawn in multiple line",
                        mode: "info",
                        icon: "mission",
                    })
                }
            />
            <Button
                label="Show stacked"
                onPress={() => {
                    void showSnackbar({ text: "First snackbar", mode: "success" });
                    void showSnackbar({ text: "Second snackbar", mode: "info" });
                    void showSnackbar({
                        text: "Third snackbar, long enough to wrap onto several lines and push the stack up",
                        mode: "error",
                    });
                }}
            />
            <Button label="CLEAR ALL" buttonMode="outlined" onPress={clearSnackbar} />
        </VStack>
    );
};

const meta = {
    title: "Components/Snackbar",
    component: ComponentStory,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
